<div class="relative flex w-full justify-center border-b">
  <canvas class="w-full" #hoursBalanceChart></canvas>
</div>
